import {
  SHOW_LOADING_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_ERROR,
  SET_USER_SELECTED,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  SET_EDIT_FIELD,
  SET_LEGAL_AGENT_USER,
  USERS_SET_FILTER,
  USERS_RESET_FILTER,
  SET_PHONE_USER_SELECTED,
  GET_OPSCORE_SUCCESS,
  GET_OPSCORE_ERROR,
} from './actionTypes';

const initialFilter = { searchName: '', selectedRol: '' };

const initialState = {
  list: [],
  selected: null,
  orderBy: 'recientes',
  loading: false,
  field: '',
  filter: initialFilter,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADING_USERS:
      return {
        ...state,
        loading: true,
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        list: action.payload,
      };
    case SET_EDIT_FIELD: {
      return {
        ...state,
        field: action.payload,
      };
    }
    case GET_USERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SET_USER_SELECTED:
      return {
        ...state,
        selected: action.payload,
      };
    case SET_PHONE_USER_SELECTED:
      return {
        ...state,
        selected: { ...state.selected, phone: action.payload },
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        list: [state.list.filter((item) => item !== action.payload.id)],
      };
    case DELETE_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SET_LEGAL_AGENT_USER:
      return {
        ...state,
        list: state.list.map((user) => {
          if (user.is_legal_agent) {
            return { ...user, ...action.payload };
          }
          return user;
        }),
      };

    case USERS_SET_FILTER: {
      return {
        ...state,
        filter: action.payload,
      };
    }

    case USERS_RESET_FILTER: {
      return {
        ...state,
        filter: initialFilter,
      };
    }

    case GET_OPSCORE_SUCCESS:
      return {
        ...state,
        opscore: action.payload,
      };
    case GET_OPSCORE_ERROR:
      return {
        ...state,
        error: action.payload,
        opscore: null,
      };

    default:
      return { ...initialState, ...state };
  }
};
